var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlatnoscPrzelewem48 = function SvgPlatnoscPrzelewem48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "platnosc_przelewem_48_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".platnosc_przelewem_48_svg__st1{fill:none;stroke:#010101;stroke-width:1.3;stroke-linecap:round;stroke-miterlimit:10}")), /*#__PURE__*/React.createElement("path", {
    d: "M42 38.2H5.5c-.6 0-1-.5-1-1V11.7c0-.6.4-1 1-1H42c.5 0 1 .4 1 1v25.5c0 .6-.4 1-1 1z",
    style: {
      fill: "none",
      stroke: "#010101",
      strokeWidth: 1.3,
      strokeMiterlimit: 10
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "platnosc_przelewem_48_svg__st1",
    d: "M9 16.7h11M27 16.7h11M9 20.7h29M9 24.7h29M9 28.7h29M9 32.7h29"
  })));
};
export default SvgPlatnoscPrzelewem48;